module.exports = window["MaterialUI"].Backdrop;